var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-feedback" },
    [
      _c("h1", {
        staticClass: "order-feedback__headline insicht insicht--fade-up",
        domProps: { innerHTML: _vm._s(_vm.$t("order.feedback.title")) }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "order-feedback__text insicht insicht--fade-up",
        domProps: { innerHTML: _vm._s(_vm.$t("order.feedback.text")) }
      }),
      _vm._v(" "),
      _vm.tokenValue
        ? _c(
            "ul",
            { staticClass: "order-feedback__info insicht insicht--fade-up" },
            [
              _vm.channelName
                ? _c(
                    "li",
                    { staticClass: "order-feedback__info-item" },
                    [
                      _c("SVGLocation"),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.channelName) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.deliveryDate
                ? _c(
                    "li",
                    { staticClass: "order-feedback__info-item" },
                    [
                      _c("SVGDate"),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.deliveryDate) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.timeDisabled && _vm.deliveryTime
                ? _c(
                    "li",
                    { staticClass: "order-feedback__info-item" },
                    [
                      _c("SVGClock"),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.deliveryTime) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.shippingMethod
                ? _c(
                    "li",
                    { staticClass: "order-feedback__info-item" },
                    [
                      _vm.shippingMethod && _vm.shippingMethod.code
                        ? _c(
                            _vm.shippingMethodIconComponent(
                              _vm.shippingMethod.code
                            ),
                            { tag: "component" }
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.shippingMethod.name) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.payments, function(payment, i) {
                return !_vm.paymentDisabled
                  ? _c(
                      "li",
                      {
                        key: "payment-" + i,
                        staticClass: "order-feedback__info-item"
                      },
                      [
                        _c(
                          _vm.iconComponent(payment.method.code) ||
                            _vm.iconComponent("datatrans"),
                          { tag: "component" }
                        ),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(payment.method.name) }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              !_vm.billingAddressDisabled && _vm.billingAddress
                ? _c("li", { staticClass: "order-feedback__info-item" }, [
                    _c("address", {
                      directives: [
                        {
                          name: "sanitize",
                          rawName: "v-sanitize",
                          value: _vm.formatAddress(_vm.billingAddress),
                          expression: "formatAddress(billingAddress)"
                        }
                      ]
                    })
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tokenValue
        ? _c(
            "div",
            { staticClass: "order-feedback__block insicht insicht--fade-up" },
            [
              _c(
                "h2",
                { staticClass: "order-feedback__block-title text--highlight" },
                [
                  _c("SVGTip", {
                    staticClass: "order-feedback__block-title-icon"
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("order.feedback.tipTitle"))
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "order-feedback__block-text",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("order.feedback.tipText"))
                }
              }),
              _vm._v(" "),
              _vm.tipResponse.message
                ? _c("GeneralMessage", {
                    attrs: {
                      message: _vm.tipResponse.message,
                      type: _vm.tipResponse.type
                    },
                    on: {
                      close: function($event) {
                        _vm.tipResponse.message = ""
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("TipInput", {
                attrs: {
                  options: _vm.cartTipVariant.options,
                  selected: _vm.cartTipOption,
                  tip: _vm.cartTip,
                  "tip-percent": _vm.cartTipPercent,
                  locked: _vm.loading || _vm.tipSubmitted
                },
                on: {
                  "tip:option": _vm.onTipOption,
                  "tip:percent": _vm.onTipPercent,
                  "tip:value": _vm.onTipValue
                }
              }),
              _vm._v(" "),
              _vm.cartTip
                ? _c("Button", {
                    attrs: {
                      level: "primary",
                      text: _vm.$t("order.feedback.tipButton"),
                      disabled: _vm.loading || _vm.tipSubmitted,
                      small: ""
                    },
                    on: { click: _vm.onTipSubmit }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tokenValue
        ? _c(
            "div",
            { staticClass: "order-feedback__block insicht insicht--fade-up" },
            [
              _c(
                "h2",
                { staticClass: "order-feedback__block-title" },
                [
                  _c("SVGStar", {
                    staticClass: "order-feedback__block-title-icon"
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("order.feedback.productFeedbackTitle")
                      )
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "order-feedback__block-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("order.feedback.productFeedbackText")
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "order-feedback__products" },
                _vm._l(_vm.itemsWithoutAdditional, function(item) {
                  return _c(
                    "li",
                    { key: item.id, staticClass: "order-feedback__product" },
                    [
                      _c(
                        "div",
                        { staticClass: "order-feedback__product-wrapper" },
                        [
                          _c("img", {
                            staticClass: "order-feedback__product-image",
                            attrs: { src: item.image }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order-feedback__product-content" },
                            [
                              _c("ProductRating", {
                                staticClass: "order-feedback__product-rating",
                                attrs: { rating: item.averageRatings }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "order-feedback__product-name",
                                domProps: { innerHTML: _vm._s(item.name) }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass:
                                  "order-feedback__product-description",
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.shortDescription || item.description
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("Button", {
                        staticClass: "order-feedback__product-button",
                        attrs: {
                          level: _vm.productsReviewed[item.code]
                            ? "secondary"
                            : "primary",
                          type: "button",
                          text: _vm.$t("order.feedback.productFeedbackButton"),
                          small: ""
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onProductFeedback(item)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.orderSurveyUrl
        ? [
            _c(
              "div",
              { staticClass: "order-feedback__block insicht insicht--fade-up" },
              [
                _c("h3", {
                  staticClass: "order-feedback__block-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("checkout.success.survey.title"))
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "order-feedback__block-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("checkout.success.survey.text"))
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "primary",
                    text: _vm.$t("checkout.success.survey.button"),
                    href: _vm.orderSurveyUrl,
                    target: "_blank",
                    arrow: "",
                    small: ""
                  }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_ORDER_NPS") && _vm.orderNpsSurveyUrl
        ? [
            _c(
              "div",
              { staticClass: "order-feedback__block insicht insicht--fade-up" },
              [
                _c("h3", {
                  staticClass: "order-feedback__block-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("checkout.success.nps.title"))
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "order-feedback__block-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("checkout.success.nps.text"))
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "primary",
                    text: _vm.$t("checkout.success.nps.button"),
                    href: _vm.orderNpsSurveyUrl,
                    target: "_blank",
                    arrow: "",
                    small: ""
                  }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.orderLocation && _vm.orderLocation.tripAdvisorUrl
        ? _c(
            "div",
            { staticClass: "order-feedback__block insicht insicht--fade-up" },
            [
              _c(
                "h2",
                { staticClass: "order-feedback__block-title" },
                [
                  _c("SVGLocation", {
                    staticClass: "order-feedback__block-title-icon"
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("order.feedback.feedbackTitle"))
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "order-feedback__block-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("order.feedback.feedbackText", {
                      channel: _vm.channelName
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c("Button", {
                attrs: {
                  level: "primary",
                  text: _vm.$t("order.feedback.feedbackButton"),
                  href: _vm.orderLocation.tripAdvisorUrl,
                  target: "_blank",
                  arrow: "",
                  small: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "reviewModal",
          attrs: {
            "overlay-type": "product-review",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
            "soft-close": ""
          },
          on: { softclose: _vm.onReviewSoftClose }
        },
        [
          _vm.modalProduct
            ? [
                _c(
                  "div",
                  { staticClass: "overlay-dialog" },
                  [
                    _c("h2", {
                      staticClass: "overlay-dialog__title",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("order.feedback.feedbackFormTitle")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "overlay-dialog__text",
                      domProps: { innerHTML: _vm._s(_vm.modalProduct.name) }
                    }),
                    _vm._v(" "),
                    _c("ProductReviewForm", {
                      ref: "reviewForm",
                      attrs: { code: _vm.modalProduct.code },
                      on: { reviewed: _vm.onProductReviewed }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }